import { apiService } from './api';
import type { PaginatedResponse, Registration, SendMessageRequest, ApiResponse } from '../types';

class RegistrationService {
  async getRegistrations(params: {
    page: number;
    limit: number;
    status?: string;
    fromDate?: string;
    toDate?: string;
    callContext?: string;
    isActive?: boolean | null;
    searchType?: 'callNumber' | 'lineUserId';
    searchValue?: string;
  }): Promise<PaginatedResponse<Registration>> {
    const queryParams = new URLSearchParams();
    queryParams.append('page', params.page.toString());
    queryParams.append('limit', params.limit.toString());
    
    if (params.status) queryParams.append('status', params.status);
    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);
    if (params.callContext) queryParams.append('callContext', params.callContext);
    if (params.isActive !== null && params.isActive !== undefined) {
      queryParams.append('isActive', params.isActive.toString());
    }
    if (params.searchType && params.searchValue) {
      queryParams.append('searchType', params.searchType);
      queryParams.append('searchValue', params.searchValue);
    }

    return apiService.get<PaginatedResponse<Registration>>(
      `/v1/admin/registrations?${queryParams.toString()}`
    );
  }

  async sendMessage(request: SendMessageRequest): Promise<ApiResponse> {
    return apiService.post<ApiResponse>('/v1/admin/send-message', request);
  }

  async updateStatus(registrationId: string, status: string): Promise<ApiResponse> {
    return apiService.put<ApiResponse>(`/v1/admin/registrations/${registrationId}/status`, {
      status,
    });
  }

  async getStatistics(): Promise<{
    todayCount: number;
    waitingCount: number;
  }> {
    return apiService.get<{
      todayCount: number;
      waitingCount: number;
    }>('/v1/admin/registrations/statistics');
  }

  // Individual statistics methods
  async getTodayRegistrationsCount(): Promise<{ count: number }> {
    return apiService.get<{ count: number }>('/v1/admin/statistics/today-registrations');
  }

  async getTodayWaitingGuestsCount(): Promise<{ count: number }> {
    return apiService.get<{ count: number }>('/v1/admin/statistics/today-waiting-guests');
  }

  async deleteRegistration(registrationId: string): Promise<ApiResponse> {
    return apiService.delete<ApiResponse>(`/v1/admin/registrations/${registrationId}`);
  }
}

export const registrationService = new RegistrationService();